import React, { useState, useEffect } from 'react';
import Layout from '../shared/Layout';
import JefaturaConsultasEstudiantes from '../jefatura/JefaturaConsultasEstudiantes';
import JefaturaHistorialAcademico from '../jefatura/JefaturaHistorialAcademico';
import JefaturaConsultasAsignaturas from '../jefatura/JefaturaConsultasAsignaturas';

const RectoradoDashboard = ({ onLogout, userName = 'Usuario', menuItems: externalMenuItems }) => {
    const [menuItems, setMenuItems] = useState([]);
    const [activeMenu, setActiveMenu] = useState('rectorado_consulta_asignaturas');

    useEffect(() => {
        // Menús fijos para Rectorado (Solo Consultas de Jefatura)
        const defaultMenus = [
            {
                id: 'rectorado_consultas',
                label: 'Consultas',
                children: [
                    { id: 'rectorado_consulta_asignaturas', label: 'Asignaturas' },
                    { id: 'rectorado_consulta_historial', label: 'Historial Académico' },
                    { id: 'rectorado_consulta_estudiantes', label: 'Estudiantes' },
                ]
            }
        ];

        // Si existen menús externos (desde DB), los filtramos o mapeamos si es necesario.
        // Pero para Rectorado, el requerimiento es que tenga exactamente lo mismo que Consultas de Jefatura.
        if (externalMenuItems && externalMenuItems.length > 0) {
            // Podríamos filtrar de los menús de la DB si es que el rol rectorado ya los tiene asignados.
            // Por ahora, para asegurar la funcionalidad solicitada, usamos la estructura fija que espeja a Jefatura.
            setMenuItems(defaultMenus);
        } else {
            setMenuItems(defaultMenus);
        }
    }, [externalMenuItems]);

    const renderContent = () => {
        switch (activeMenu) {
            case 'rectorado_consulta_estudiantes':
                return <JefaturaConsultasEstudiantes readOnly={true} />;
            case 'rectorado_consulta_historial':
                return <JefaturaHistorialAcademico readOnly={true} />;
            case 'rectorado_consulta_asignaturas':
                return <JefaturaConsultasAsignaturas readOnly={true} />;
            default:
                return (
                    <div className="p-8 text-center">
                        <div className="bg-white rounded-2xl shadow-sm p-12 max-w-2xl mx-auto border border-gray-100">
                            <h2 className="text-3xl font-black text-blue-950 mb-4">Bienvenido al Portal de Rectorado</h2>
                            <p className="text-gray-500 font-medium leading-relaxed">
                                Seleccione una opción del menú lateral para visualizar los reportes académicos consolidados en modo de solo lectura.
                            </p>
                        </div>
                    </div>
                );
        }
    };

    return (
        <Layout
            menuItems={menuItems}
            activeMenu={activeMenu}
            setActiveMenu={setActiveMenu}
            onLogout={onLogout}
            userName={userName}
            userRole="Rectorado"
        >
            {renderContent()}
        </Layout>
    );
};

export default RectoradoDashboard;
